import React from 'react';

const AboutBanner = () =>{
    return (
        <>
        <div className='cadAboutUsMainBanner cadAboutBanner cadContactBanner'>
            <img 
            src="/banners/about-us.jpg"
            alt="cadandrender-about-us" />
            <div className='container'>
                <div className='cadContactBannerContent'>
                    <h1>About Us</h1>
                </div>
            </div>
        </div>
        </>
    );
}

export default AboutBanner;